import { assert } from '@sama/js-core';
import { TRAINING_SHAPE_COLOR } from '../../../../../cross-team-shared/constants';
import { PointCloudContentState } from '../../../../state/point-cloud-content-state';
import { PolygonHelper } from './polygon-helper';

export class TrainingPolygonHelper extends PolygonHelper {
  override getPolyShapeName() {
    return `training-${super.getPolyShapeName()}`;
  }

  protected override getShapeState(state: PointCloudContentState) {
    const polygon = state.render.trainingShapes.polygons[this.index];
    assert(polygon, 'polygon should exist');
    return polygon;
  }

  protected override getShapeColor(_state: PointCloudContentState) {
    return TRAINING_SHAPE_COLOR;
  }
}
